import { colors } from '../../colors';
var pencilBanner = {
  bgColor: colors.cream,
  textColor: colors.ash,
  textColorDark: colors.ash,
  textColorLight: colors.white
};
export default pencilBanner;